import Grid from "@mui/material/Grid";
import { Container } from "@mui/system";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import intensiteIcon from "../../src/assets/images/picto-eclair.svg";
import calorieIcon from "../../src/assets/images/picto-feu.svg";
import dureeIcon from "../../src/assets/images/picto-horloge.svg";
import teteIcon from "../../src/assets/images/picto-main.svg";
import { GoPloof } from "../components/organisms/GoPloof";
import MetaMaster from "../components/utils/MetaMaster";
import { Button } from "../stories/atoms/Button";

// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";

// import des infos des activités
import activites from "../components/utils/Activities";
import SanitizeDiv from "../components/utils/Sanitize";
import { HeroInner } from "../stories/organisms/HeroInner";

export default function ActiviteBebe() {
    const [arianeItem, setArianeItem] = useState();
    const [activite, setActivite] = useState();
    const [activiteIsLoading, setActiviteIsLoading] = useState(true);

    useEffect(() => {
        const bebeActivity = activites.find((a) => a.slug === "bebes-nageurs" || a.slug?.includes?.("bebes-nageurs"));

        if (bebeActivity) {
            setActivite(bebeActivity);
            setActiviteIsLoading(false);
            setArianeItem([
                ["/", "Vital'Eau"],
                ["/activites", "Nos activités"],
                ["/activites/bebes-nageurs", bebeActivity.titre],
            ]);
        }
    }, []); // ✅ aucune dépendance

    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    };

    return (
        <div className="template-activity">
            {!activiteIsLoading && (
                <>
                    <MetaMaster title={"Vital'eau - " + activite.titre} />
                    <HeroInner arianeItem={arianeItem} imagesSwiper={[activite.src]} />
                    <section className="section-show-pool-home section-activite-inner" id="accueil-histoire">
                        <Container maxWidth="lg">
                            <Grid container>
                                <Grid item lg={11} md={10} sm={12} xs={12}>
                                    <div>
                                        <Button onClick={goBack} primary label={"Retour"} />
                                        <br />
                                        <h1 className="accueil-histoire-titre h1-inner" data-title={activite.titre}>
                                            {activite.titre}
                                        </h1>
                                        <p id="accueil-histoire-baseline">{activite.introtext}</p>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container justifyContent={"space-between"} spacing={6}>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <div>
                                        <SanitizeDiv content={activite.text} className="container-info-activite-texte" />
                                    </div>
                                </Grid>
                                <Grid item lg={5} md={5} sm={12} xs={12} className="container-info-activite-duree">
                                    <div className="grid-info-activitee-picto">
                                        {activite.duree && (
                                            <div className="align-info-activite-picto">
                                                <img
                                                    src={dureeIcon}
                                                    alt="Picto durée de l'activité"
                                                    className="activite-intro-picto"
                                                    title="Picto durée de l'activité"
                                                    loading="lazy"
                                                />
                                                <div>
                                                    <p className="bold title-info-activite-int">
                                                        {activite.duree.label}
                                                        <br />
                                                        <span>{activite.duree.value}</span>
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                        {activite.intensite && (
                                            <div className="align-info-activite-picto">
                                                <img
                                                    src={intensiteIcon}
                                                    alt="Picto intensité de l'activité"
                                                    className="activite-intro-picto"
                                                    title="Picto intensité de l'activité"
                                                    loading="lazy"
                                                />
                                                <div>
                                                    <p className="bold title-info-activite-int">
                                                        {activite.intensite.label}
                                                        <br />
                                                        <span>{activite.intensite.value}</span>
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                        {activite.participants && (
                                            <div className="align-info-activite-picto">
                                                <img
                                                    src={teteIcon}
                                                    alt="Picto nombre de personne dans un bassin"
                                                    className="activite-intro-picto"
                                                    title="Picto nombre de personne dans un bassin"
                                                    loading="lazy"
                                                />
                                                <div>
                                                    <p className="bold title-info-activite-int">
                                                        {activite.participants.label}
                                                        <br />
                                                        <span>{activite.participants.value}</span>
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                        {activite.calories && (
                                            <div className="align-info-activite-picto">
                                                <img
                                                    src={calorieIcon}
                                                    alt="Picto nombre de calories brulées"
                                                    className="activite-intro-picto"
                                                    title="Picto nombre de calories brulées"
                                                    loading="lazy"
                                                />
                                                <div>
                                                    <p className="bold title-info-activite-int">
                                                        {activite.calories.label}
                                                        <br />
                                                        <span>{activite.calories.value}</span>
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div style={{ position: "relative", paddingTop: "56.25%", marginTop: "52px" }}>
                                        <iframe
                                            src="https://www.youtube-nocookie.com/embed/xTSMU4veOCM"
                                            title="YouTube video player"
                                            style={{
                                                position: "absolute",
                                                inset: 0,
                                                width: "100%",
                                                height: "100%",
                                                border: 0,
                                            }}
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            allowFullScreen
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </Container>
                    </section>

                    {activite.descrption && (
                        <section id="activite-description">
                            <Container maxWidth="lg">
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <div>
                                        <h2>{activite.descrption.titre}</h2>
                                        <p className="baseline">{activite.descrption.baseline}</p>
                                    </div>
                                </Grid>
                            </Container>
                            <Container maxWidth="lg">
                                <Grid container spacing={6} justifyContent="space-between">
                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <SanitizeDiv content={activite.descrption.text} className="container-info-activite-texte" />
                                    </Grid>
                                    {activite.descrption.horaire && (
                                        <Grid item lg={5} md={6} sm={12} xs={12}>
                                            <div className="horaire-description">
                                                <h2>Les horaires</h2>
                                                <SanitizeDiv content={activite.descrption.horaire} className="container-info-activite-texte" />
                                            </div>
                                        </Grid>
                                    )}
                                </Grid>
                            </Container>
                        </section>
                    )}

                    {activite.swiper && (
                        <Swiper
                            slidesPerView={1}
                            autoplay={{
                                delay: 5000,
                                disableOnInteraction: false,
                            }}
                            modules={[Autoplay]}
                            className="mySwiper swiperActivite"
                        >
                            {activite.swiper.map((activiteswiper, index) => (
                                <SwiperSlide key={index}>
                                    <img
                                        src={activiteswiper.images}
                                        alt={activiteswiper.text}
                                        width={"100%"}
                                        height={800}
                                        title={activiteswiper.text}
                                        loading="lazy"
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    )}

                    {activite.bienfaits && (
                        <section id="activites-bienfaits">
                            <Container maxWidth="lg">
                                <Grid container spacing={2} justifyContent="space-between" alignItems="center">
                                    <Grid item xs={12}>
                                        <h2>{activite.bienfaits.titre}</h2>
                                        {activite.bienfaits.baseline && <p className="baseline">{activite.bienfaits.baseline}</p>}
                                        {activite.bienfaits.swiper ? (
                                            <Swiper
                                                slidesPerView={3}
                                                spaceBetween={30}
                                                // autoplay={{
                                                //     delay: 5000,
                                                //     disableOnInteraction: false,
                                                // }}
                                                navigation={true}
                                                modules={[Navigation]}
                                                className="mySwiper swiperBienfaits"
                                                breakpoints={{
                                                    // mobile portrait
                                                    0: {
                                                        slidesPerView: 1,
                                                        spaceBetween: 10,
                                                    },
                                                    // tablettes
                                                    640: {
                                                        slidesPerView: 1.5,
                                                        spaceBetween: 20,
                                                    },
                                                    // tablettes paysage
                                                    768: {
                                                        slidesPerView: 2,
                                                        spaceBetween: 25,
                                                    },
                                                    // desktop
                                                    1024: {
                                                        slidesPerView: 3,
                                                        spaceBetween: 30,
                                                    },
                                                    // écrans larges
                                                    1440: {
                                                        slidesPerView: 3,
                                                        spaceBetween: 40,
                                                    },
                                                }}
                                            >
                                                {activite.bienfaits.swiper.map((bienfaitsswiper, index) => (
                                                    <SwiperSlide key={index}>
                                                        <div id={`activite-bienfaits-numbers`}>
                                                            <div className="number-text">
                                                                <span>{index + 1}</span>
                                                            </div>
                                                            <SanitizeDiv content={bienfaitsswiper.text} />
                                                        </div>
                                                    </SwiperSlide>
                                                ))}
                                            </Swiper>
                                        ) : (
                                            <p>{activite.bienfaits.text}</p>
                                        )}
                                    </Grid>
                                </Grid>
                            </Container>
                        </section>
                    )}

                    {activite.pourqui && (
                        <section id="activites-pourqui">
                            <Container maxWidth="lg">
                                <Grid container spacing={2} justifyContent="space-between" alignItems="center">
                                    <Grid item md={8} xs={12}>
                                        <h2>{activite.pourqui.titre}</h2>
                                        <p className="baseline">{activite.pourqui.baseline}</p>
                                        <p>{activite.pourqui.text}</p>
                                    </Grid>
                                </Grid>
                            </Container>
                        </section>
                    )}

                    {activite.seance && (
                        <section id="activite-deroulement">
                            <Container maxWidth="lg">
                                <Grid container>
                                    <Grid item xs={12}>
                                        <h2>Déroulement d'une séance</h2>
                                        {activite.seancebaseline && <p className="baseline">{activite.seancebaseline}</p>}
                                        <div>
                                            <Grid container>
                                                {activite.seance.map((activiteseance, index) => (
                                                    <Grid item lg={3} md={3} sm={6} xs={12} className="activite-deroulement-liste" key={index}>
                                                        <div id={`activite-deroulement-${activiteseance.number}`}>
                                                            <p className="number-text">{activiteseance.number}</p>
                                                            <p>{activiteseance.text}</p>
                                                        </div>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Container>
                        </section>
                    )}

                    {(activite.enpratique || activite.sac) && (
                        <section id="en-pratique">
                            <Container maxWidth="lg">
                                <Grid container spacing={6} justifyContent="space-between">
                                    {activite.enpratique && (
                                        <Grid item lg={5} md={6} sm={12} xs={12}>
                                            <h2>{activite.enpratique.titre || "En pratique"}</h2>
                                            <p className="baseline">{activite.enpratique.baseline || "on vous dit tout"}</p>

                                            <ul id="en-pratique-liste">
                                                {activite.enpratique.items?.map((item, index) => (
                                                    <li key={index}>
                                                        <div className="number-text">
                                                            <span>{item.number}</span>
                                                        </div>
                                                        <p>{item.text}</p>
                                                    </li>
                                                ))}
                                            </ul>
                                        </Grid>
                                    )}
                                    {activite.sac && (
                                        <Grid item lg={5} md={6} sm={12} xs={12}>
                                            <div className="sac-piscine-container">
                                                <h2>Mon sac de piscine</h2>
                                                <p className="baseline">À apporter pour les séances</p>

                                                <ul id="sac-piscine-liste">
                                                    {activite.sac.map((sacpiscine, index) => (
                                                        <li key={index}>{sacpiscine.text}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </Grid>
                                    )}
                                    <Grid item lg={5} md={6} sm={12} xs={12}>
                                        <div style={{ position: "relative", paddingTop: "56.25%", marginTop: "52px" }}>
                                            <iframe
                                                src="https://www.youtube-nocookie.com/embed/9S5_JS0qEr0"
                                                title="YouTube video player"
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    width: "100%",
                                                    height: "100%",
                                                    border: 0,
                                                }}
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                allowFullScreen
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </Container>
                        </section>
                    )}

                    <GoPloof profil={activite.profil} />

                    <section className="section-contact">
                        <Container maxWidth="xl">
                            <Grid container justifyContent={"center"}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <div>
                                        <h2 className="accueil-histoire-titre" data-title="Ça te plaît ? ">
                                            Ça te plaît ?, <br />
                                            par ici les horaires
                                        </h2>
                                        <br />
                                        <br />
                                        <Button label="Planning" style={{ width: "fit-content", margin: "0 auto" }} primary href={"/planning"} />
                                    </div>
                                </Grid>
                            </Grid>
                        </Container>
                    </section>
                </>
            )}
        </div>
    );
}
